module.exports = __webpack_public_path__ + "img/media (13).b24cebb4.png";